import { motion } from 'framer-motion';
import { CreditCard, ArrowRight, Shield, CheckCircle } from 'lucide-react';
import { Button } from '../ui/button';

export default function BillingCancel({ navigate, isAuthenticated }) {
  return (
    <div className="min-h-screen bg-[#0A0A0B] flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-md w-full text-center"
        data-testid="billing-cancel-page"
      >
        <div className="w-16 h-16 rounded-2xl bg-indigo-500/10 flex items-center justify-center mx-auto mb-6">
          <CreditCard className="w-8 h-8 text-indigo-400" />
        </div>
        <h2 className="text-2xl font-medium text-white mb-3">
          Complete your setup to start your free trial
        </h2>
        <p className="text-zinc-400 mb-6 leading-relaxed">
          Finish secure checkout to activate your account.
        </p>

        <div className="flex flex-wrap justify-center gap-4 mb-8 text-sm text-zinc-400">
          <span className="flex items-center gap-1"><CheckCircle className="w-4 h-4 text-emerald-400" />No commitment</span>
          <span className="flex items-center gap-1"><CheckCircle className="w-4 h-4 text-emerald-400" />Cancel anytime</span>
          <span className="flex items-center gap-1"><CheckCircle className="w-4 h-4 text-emerald-400" />Enterprise-grade security</span>
        </div>

        <div className="flex flex-col gap-3">
          {isAuthenticated ? (
            <>
              <Button
                onClick={() => navigate('/billing/complete-setup')}
                className="w-full bg-indigo-600 hover:bg-indigo-500 text-white h-12"
                data-testid="cancel-continue-setup"
              >
                Continue Setup <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
              <div className="flex items-center justify-center gap-2 text-zinc-600 text-xs">
                <Shield className="w-3.5 h-3.5" />
                <span>Secure checkout powered by Stripe</span>
              </div>
            </>
          ) : (
            <Button
              onClick={() => navigate('/login')}
              className="w-full bg-indigo-600 hover:bg-indigo-500 text-white h-12"
              data-testid="cancel-go-login"
            >
              Sign In to Continue <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          )}
        </div>
      </motion.div>
    </div>
  );
}
